import { MenuFoldOutlined, MenuUnfoldOutlined, LogoutOutlined, MessageOutlined, MailOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { DarkModeSwitch } from "react-toggle-dark-mode";
import { Button, Col, Row } from "antd";
import { Link } from "react-router-dom";
import styles from "./Header.module.css";

function Header({ onPress, collapsed, handleCollapsed }) {

  const isLogged = Boolean(localStorage.getItem("access-token"));

  const [isDarkMode, setDarkMode] = useState(false);
  const [userName, setUserName] = useState("");

  // 🌙 DARK MODE
  const toggleDarkMode = (checked) => {
    setDarkMode(checked);
  };

  useEffect(() => {
    document.body.className = isDarkMode ? "dark-theme" : "light-theme";
  }, [isDarkMode]);


  
  // ✅ GET USERNAME FROM LOCALSTORAGE
  useEffect(() => {
    const name = localStorage.getItem("username");
    if (name) {
      setUserName(name);
    }
  }, []);

  return (
    <>
      <Row gutter={[24, 0]}>

        {/* SIDEBAR */}
        <Col span={24} md={4}>
          <div className={styles.sidebarTogglerPC}>
            {isLogged &&
              React.createElement(
                collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
                {
                  className: `${styles.trigger}`,
                  onClick: () => handleCollapsed(!collapsed),
                }
              )}
          </div>
        </Col>

        {/* RIGHT SIDE */}
        <Col span={24} md={20} className={styles.headerControl}>

          {/* DARK MODE */}
          <DarkModeSwitch
            style={{ margin: "1rem" }}
            checked={isDarkMode}
            onChange={toggleDarkMode}
            size={20}
          />

          {/* ✅ CHAT ICON (MOVE HERE) */}
          {isLogged && (
            <Link to="/chat">
              <Button
                type="text"
                icon={
                  <MessageOutlined
                    style={{ fontSize: "20px", color: "#1890ff" }}
                  />
                }
              />
            </Link>
          )}

          {/* 📧 EMAIL ICON */}
          {isLogged && (
            <Link to="/email">
              <Button
                type="text"
                icon={
                  <MailOutlined
                    style={{ fontSize: "20px", color: "#52c41a" }}
                  />
                }
              />
            </Link>
          )}

          {/* LOGIN */}
          {!isLogged && (
            <Link to="/admin/auth/login" className="btn-sign-in text-dark">
              Login
            </Link>
          )}

          {/* MOBILE MENU */}
          {isLogged && (
            <Button
              type="link"
              className={styles.sidebarTogglerMobile}
              onClick={() => onPress()}
              style={{ boxShadow: "none", color: "#fff" }}
            >
              ☰
            </Button>
          )}

          {/* USERNAME + LOGOUT */}
          {isLogged && (
            <div style={{ display: "flex", alignItems: "center", gap: "10px", color: "#fff" }}>
              
              <span style={{ fontWeight: "bold", color: "#000" }}>
                {userName || "User"}
              </span>

              <Link to="/admin/auth/logout">
                <Button
                  type="text"
                  icon={
                    <LogoutOutlined
                      style={{ fontSize: "18px", color: "red" }}
                    />
                  }
                />
              </Link>

            </div>
          )}

        </Col>
      </Row>
    </>
  );
}

export default Header;